import { objectsRHandler } from '@/utils/objectsRHandler';
import BaseModel from '../../base';
import constants from './constants';
import glossary from './glossary';
import AssociationFeatureValue from './value';

export default class AssociationFeature extends BaseModel {
  constructor(item = {}, url) {
    super(item, url);
    this.event_association_id = item.event_association_id;

    this.created_at = item.created_at;
    this.updated_at = item.updated_at;

    this.values = (Array.isArray(item.values) ? item.values : []).map((i) => new AssociationFeatureValue(i));
  }

  static get constants() {
    return constants;
  }

  static get glossary() {
    return glossary;
  }

  get api() {
    const { url, id } = this;
    return {
      get values() {
        const path = `${url}/${id}/values`;
        return {
          ...objectsRHandler(path, AssociationFeatureValue),
        };
      },
    };
  }
}
